import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ValidationProblem, Order, Party, OrderManagerService, ValidationService } from 'reg-hub-common';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { SteppedComponent } from 'projects/reg-hub-client/src/interfaces/stepped-component';
import { BehaviorSubject, filter, take } from 'rxjs';

@Component({
  selector: 'app-know-your-customer-criteria-review-component',
  templateUrl: './know-your-customer-criteria-review-component.component.html',
  styleUrl: './know-your-customer-criteria-review-component.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class KnowYourCustomerCriteriaReviewComponentComponent extends SteppedComponent {
  protected party$ = new BehaviorSubject<Party[]>([]);

  constructor(
    orderManager: OrderManagerService,
    validationService: ValidationService) { super(orderManager, validationService); }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.order.knowYourCustomerCriteria?.party) {
      this.party$.next([this.order.knowYourCustomerCriteria.party]);
    }

    this.orderManager.saving$.pipe(
      filter(val => !val),
      take(1)
    ).subscribe(() => {
      if (this.order.knowYourCustomerCriteria?.party) {
        this.party$.next([this.order.knowYourCustomerCriteria.party]);
      }
    });
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return errors?.length === 0 ? StepValidationState.ValidationSuccess : StepValidationState.ValidationError;
  }
}
